import { styled } from '@mui/material'

export const ValuePanelInputRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
})
